// replaced google+ share button with a button that links to client's Instagram page.
// this is not meant to allow users to share hub on Instagram

const replaceGooglePlus = () => {
  $('#share-main-hub > li:nth-of-type(6)').html(`<a class="instagram on hooked" href="https://instagram.com/nwea?utm_source=ig_profile_share&igshid=1unw4306i0evv">Instagram</a>`);
};

export { replaceGooglePlus };



// WEBPACK FOOTER //
// ./custom-js/instagramLink.js